import { Card, CardContent } from "@/components/ui/card";

/**
 * Small metadata card for the right column on detail pages.
 * ``fields`` = [{ label, value, testId? }]
 */
export default function MetaCard({ title, fields = [] }) {
  return (
    <Card className="rounded-md">
      <CardContent className="p-4 space-y-3">
        {title && (
          <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
            {title}
          </div>
        )}
        <dl className="space-y-2.5">
          {fields.map((f, i) => (
            <div key={i} className="flex items-start justify-between gap-3">
              <dt className="text-xs text-muted-foreground uppercase tracking-wider font-bold">
                {f.label}
              </dt>
              <dd className="text-sm font-medium text-right" data-testid={f.testId}>
                {f.value ?? "—"}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
